/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { accountSchema } from './account-schema';
import { contactSchema } from './contact-schema';

export const contactsAccountSchema: z.AnyZodObject = z.object({
  account: z.lazy(() => accountSchema).nullish(),
  accountId: z.string().uuid().nullish(),
  contact: z.lazy(() => contactSchema).nullish(),
  contactId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  updatedAt: z.string().datetime().nullish(),
});

export type ContactsAccount = z.infer<typeof contactsAccountSchema>;
